import { gql } from 'graphql.macro';

export const viewSupportScreenShareTemplate = gql`
    mutation viewSupportScreenShare($code: String!) {
        viewSupportScreenShare(code: $code) {
            url
            accessToken
            share {
                code
                userName
                userEmail
                organizationName
                organizationType
                startedAt
                isCustomerSharing
                viewers
            }
        }
    }
`;

export const endSupportScreenShareTemplate = gql`
    mutation endSupportScreenShare($code: String!) {
        endSupportScreenShare(code: $code)
    }
`;
